import { VISA_STATUS } from '../../constants';
import { VISA_STATUS_TEXT } from '../../lang';
import { type SelectOption } from '../../../../components';

export const visaStatusOptions: SelectOption[] = [
  {
    label: VISA_STATUS_TEXT.PENDING_APPLICATION_SUBMISSION,
    value: VISA_STATUS.PENDING_APPLICATION_SUBMISSION,
  },
  {
    label: VISA_STATUS_TEXT.APPLICATION_RECEIVED,
    value: VISA_STATUS.APPLICATION_RECEIVED,
  },
  {
    label: VISA_STATUS_TEXT.PROCESSING,
    value: VISA_STATUS.PROCESSING,
  },
  {
    label: VISA_STATUS_TEXT.APPROVED,
    value: VISA_STATUS.APPROVED,
  },
  {
    label: VISA_STATUS_TEXT.REJECTED,
    value: VISA_STATUS.REJECTED,
  },
  {
    label: VISA_STATUS_TEXT.ACTIVATED,
    value: VISA_STATUS.ACTIVATED,
  },
];
